export enum StructureName {
  DESCRIPTION = 'description',
  SOCIALS = 'socials',
  SERVICES = 'services',
  WORKING_HOURS = 'working_hours',
  LOCATION = 'location',
  // GALLERY = 'gallery',
}

export interface IStructureItem {
  name: StructureName;
  visible: boolean;
}
